export default __webpack_public_path__ + "static/Screen-Shot-2020-04-20-at-10.55.57-PM-3e0bd687e429635fb061f8b1d350bda0.png";